import React, { Component } from "react";
import Countries from "../../services/countries.service";
import DropDownIcon from "../../assets/img/MenuDropdown.svg";

export default class CountrySelectBasic extends Component {
  state = {
    selected_country: null
  };

  countries = Countries.Countries;
  country_codes = Countries.sortedCountryCodes;
  countries_list = [];

  componentDidMount() {
    this.setState({
      selected_country: this.props.defaultCountry,
      disabled: this.props.disabled
    });
  }

  constructor() {
    super();
    for (var i = 0; i < this.country_codes.length; i++) {
      this.countries_list.push(
        <option key={i} value={this.country_codes[i]}>
          {this.countries[this.country_codes[i]].CountryName} {this.countries[this.country_codes[i]].CountryCode}
        </option>
      );
    }
  }

  getFlag = (code) => {
    let flag = require("../../assets/img/flags/" +
        code.toUpperCase() +
        ".png");
    return flag;
  }

  selectCountry(event) {
    this.setState({
      selected_country: this.countries[event.target.value].ISO_2Code
    });
    if (this?.props?.form_id === "country_contact_user") {
      let iso = this.countries[event.target.value].CountryCode;
      this.props.updateFieled(event.target.value, iso)

    } else {
      this.props.updateFieled(event, 'form', 'select')
      // Forms.inputChangedHandler(this.props.form_id, event, this.props.field_name)
    }
  }

  render() {
    let country_select = "";
    let list = this.countries_list;

    if (this.state.selected_country) {
      if(this.state.disabled){
        country_select = (
          <div className="storefront-country-selected">
            <img src={this.getFlag(this.state.selected_country)} alt={this.state.selected_country} />
            <span>{this.countries[this.state.selected_country].CountryCode}</span>
          </div>

        );  
      } else {
        country_select = (
          <div className="storefront-country-picker">
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                cursor: "pointer"
            }}>
                <div className="storefront-country-selected">
                    <img src={this.getFlag(this.state.selected_country)} alt={this.state.selected_country} />
                    <span>{this.countries[this.state.selected_country].CountryCode}</span>
                </div>
                <img src={DropDownIcon} alt="" style={{margin: "0px 8px"}}/>
            </div>
            <select className="countryselectpick" name="country_select" onChange={e => this.selectCountry(e)}>{list}</select>
          </div>
        );  
      }
    }

    return country_select;
  }
}